import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import BaseArrowUpRightIcon from 'assets/svg/app/arrow-up-right-tg.svg'
import BaseLightningIcon from 'assets/svg/app/lightning.svg'
import { FlexDiv } from 'components/layout/flex'
import { Body } from 'components/Text'
import Connector from 'containers/Connector'
import { setOpenModal } from 'state/app/reducer'
import { selectCrossMarginAccount } from 'state/futures/snxPerpsV3/selectors'
import { useAppDispatch, useAppSelector } from 'state/hooks'

import useAbstractionInfo from './OneClickTrading/hooks/useAbstractionInfo'

const OneClickTradingSetupMessage = () => {
	const { t } = useTranslation()
	const { isWalletConnected } = Connector.useContainer()
	const crossMarginAccount = useAppSelector(selectCrossMarginAccount)
	const dispatch = useAppDispatch()
	const { isSessionActive } = useAbstractionInfo()

	return (
		<Container
			visible={isWalletConnected && !!crossMarginAccount && !isSessionActive}
			onClick={() => dispatch(setOpenModal('one_click_trading_onboard'))}
		>
			<StyledFlexDiv gap={5}>
				<LightningIcon width={8} height={11} />
				<Title>{t('futures.market.trade.one-click-trading-message.title')}</Title>
			</StyledFlexDiv>
			<StyledFlexDiv gap={2}>
				<Action size="xsmall">{t('futures.market.trade.one-click-trading-message.action')}</Action>
				<ArrowUpRightIcon width={11} height={11} />
			</StyledFlexDiv>
		</Container>
	)
}

const Container = styled(FlexDiv)<{ visible: boolean }>`
	${(props) => !props.visible && 'display: none'};
	cursor: pointer;
	height: 25px;
	width: 100%;
	padding: 0 15px;
	border-radius: 4px;
	justify-content: space-between;
	align-items: center;
	margin: 15px 0;
	background-color: ${(props) =>
		props.theme.colors.selectedTheme.newTheme.trade.oneClickTradingMessageBg};
`

const LightningIcon = styled(BaseLightningIcon)`
	path {
		fill: ${(props) => props.theme.colors.common.palette.yellow.y500};
	}
`

const ArrowUpRightIcon = styled(BaseArrowUpRightIcon)`
	margin-top: -4px;
	path {
		stroke: ${(props) => props.theme.colors.selectedTheme.newTheme.trade.setup};
		stroke-width: 1.5px;
	}
`

const Title = styled(Body)`
	color: ${(props) => props.theme.colors.selectedTheme.text.value};
	font-weight: 700;
`

const Action = styled(Body)`
	color: ${(props) => props.theme.colors.selectedTheme.newTheme.trade.setup};
	font-weight: 700;
`

const StyledFlexDiv = styled(FlexDiv)<{ gap: number }>`
	align-items: center;
	gap: ${({ gap }) => gap}px;
`

export default OneClickTradingSetupMessage
